<div class="template-name">
  @if (!isTemplateNameBeingEdited) {
    <div class="template-name-no-edit-mode">
      <strong>Template Name: </strong>
      {{ templateName }}
      @if (showEditIcon) {
        <i class="fas fa-pencil-alt edit-name-icon" (click)="toggleTemplateNameEditMode()"></i>
      }
    </div>
  }
  @if (isTemplateNameBeingEdited) {
    <div>
      <strong>Template Name: </strong>
      <input class="template-title-input" [value]="templateName" (input)="onTemplateNameChange($event)" placeholder="Template Name"/>
      <a class="edit-name-icon" (click)="saveTemplateName()">Save Template Name</a>
    </div>
  }
</div>